/** @jsxImportSource @emotion/react */
import { Box, Button, Chip, FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import {
  chipCss,
  containerCss,
  formControlCss,
  inputLabelCss,
  selectCss,
} from './RiskTableFilter.styles'

type ConsequenceOption = { label: string; bgColor: string; fgColor: string }

type FilterOptions = {
  elementTypes: string[]
  riskSources: string[]
  consequences: ConsequenceOption[]
}

type Filters = {
  elementType: string
  riskSource: string
  consequence: string
}

type Props = {
  filters: Filters
  setFilters: (filters: Filters) => void
  filterOptions: FilterOptions
}

export const RiskTableFilters = ({ filters, setFilters, filterOptions }: Props) => {
  function clearFilters(): void {
    setFilters({ elementType: '*', riskSource: '*', consequence: '*' })
  }

  return (
    <Box css={containerCss}>
      <FormControl css={formControlCss}>
        <InputLabel css={inputLabelCss}>Element type</InputLabel>
        <Select
          value={filters.elementType}
          onChange={(e) => setFilters({ ...filters, elementType: e.target.value })}
          css={selectCss}
        >
          <MenuItem value="*">All selected element types</MenuItem>
          {filterOptions.elementTypes.map((opt) => (
            <MenuItem key={opt} value={opt}>
              {opt}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl css={formControlCss}>
        <InputLabel css={inputLabelCss}>Risk source</InputLabel>
        <Select
          value={filters.riskSource}
          onChange={(e) => setFilters({ ...filters, riskSource: e.target.value })}
          css={selectCss}
        >
          <MenuItem value="*">All selected hazard types</MenuItem>
          {filterOptions.riskSources.map((opt) => (
            <MenuItem key={opt} value={opt}>
              {opt}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl css={formControlCss}>
        <InputLabel css={inputLabelCss}>Consequence</InputLabel>
        <Select
          value={filters.consequence}
          onChange={(e) => setFilters({ ...filters, consequence: e.target.value })}
          css={selectCss}
        >
          <MenuItem value="*">All consequences</MenuItem>
          {filterOptions.consequences.map((consequence) => (
            <MenuItem key={consequence.label} value={consequence.label}>
              <Chip
                label={consequence.label}
                size="small"
                css={chipCss({ bgColor: consequence.bgColor, fgColor: consequence.fgColor })}
              />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button variant={'text'} onClick={clearFilters}>
        Clear filters
      </Button>
    </Box>
  )
}
